import { ErrorMarkup } from 'modules/error';
import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import {
  useSendingPlatformsQueryContext,
  WhatsAppAccountsQueryContextProvider,
} from 'modules/sendingPlatforms/contexts';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';
import { MainContent, Wrapper } from '../Page.styled';
import { PageHeader } from '../PageHeader';
import { Sidebar } from '../Sidebar';
import { WhatsAppAccountsHeader } from './WhatsAppAccountsHeader';
import { WhatsAppAccountsSection } from './WhatsAppAccountsSection';

export const WhatsAppPage = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { hasError, espAccountsBySendingPlatform } = useSendingPlatformsQueryContext();
  const accounts = espAccountsBySendingPlatform[sendingPlatform];

  const { isWhatsAppEnabled } = useWhatsAppMessageChannelFeature();
  if ((hasError && accounts?.length === 0) || !isWhatsAppEnabled)
    return (
      <ErrorMarkup
        id="sending-platforms-details-error-page"
        fallbackLinkTo="/settings/sendingPlatforms"
        fallbackLinkToText="Back to Sending Platforms"
      />
    );

  return (
    <>
      <WhatsAppAccountsQueryContextProvider>
        <div>
          <PageHeader sendingPlatform={sendingPlatform} />
          <Wrapper>
            <Sidebar sendingPlatform={sendingPlatform} />
            <MainContent>
              <WhatsAppAccountsHeader sendingPlatform={sendingPlatform} />
              <WhatsAppAccountsSection sendingPlatform={sendingPlatform} />
            </MainContent>
          </Wrapper>
        </div>
      </WhatsAppAccountsQueryContextProvider>
    </>
  );
};
